import { axiosInstance } from "@/lib/axiosInstance";

export interface DashboardAnalytics {
  total_applications: number;
  application_by_status: Record<string, number>;
  total_offers: number;
  pending_offers: number;
  accepted_offers: number;
  total_interviews: number;
  /**
   * Same rule as GET /v1/interviews?upcoming=true — status=scheduled,
   * scheduled_at >= now(), parent application not withdrawn/rejected — so this
   * tile and the interviews list always agree.
   */
  upcoming_interviews: number;
}

export const fetchDashboardAnalytics = async (): Promise<DashboardAnalytics> => {
  const res = await axiosInstance.get("/v1/analytics/dashboard");
  const raw = res.data;
  // Handle standard response wrapping if present
  return raw?.data || raw;
};
